import type { CSSProperties } from 'react';

import { CenterFlex, VFlex } from '@/components/base';
import LazyLoader from '@/components/Common/LazyLoader';
import ScrollView from '@/components/Common/ScrollView';
import Spinner from '@/components/Common/Spinner';
import Transition from '@/components/Common/Transition';
import { useToast } from '@/stores/pure/ToastStore';
import { FEEDBACK_DETAIL_MODAL_SCROLL_SELECTOR } from '@/types/feedbackConst';

import FeedbackStaticDetailTemplate from '../../FeedbackDetail/FeedbackStaticDetail/FeedbackStaticDetailTemplate';
import useDetailFeedback from './hooks/useDetailFeedback';

type BodyProps = {
  feedbackAlias: string;
  style?: CSSProperties;
  focusedBlock?: string;
};

const Body = ({ feedbackAlias, style, focusedBlock }: BodyProps) => {
  const {
    data: feedbackDetail,
    isLoading,
    isError,
  } = useDetailFeedback(feedbackAlias);

  const addToast = useToast();

  if (isError) {
    addToast('Failed to fetch feedback detail', 'fail');
  }

  return (
    <ScrollView
      style={style}
      id={FEEDBACK_DETAIL_MODAL_SCROLL_SELECTOR(feedbackAlias)}
    >
      <VFlex padding="24px 32px 100px 32px">
        <Transition
          status={!isLoading}
          fallback={
            <LazyLoader
              show={isLoading}
              delay={300}
              loader={
                <CenterFlex height="300px">
                  <Spinner />
                </CenterFlex>
              }
            />
          }
        >
          {feedbackDetail && (
            <FeedbackStaticDetailTemplate
              detail={feedbackDetail}
              feedback={feedbackDetail}
              focusedBlock={focusedBlock}
            />
          )}
        </Transition>
      </VFlex>
    </ScrollView>
  );
};

export default Body;
